const useLocalStorage = (keyPrefix, defaultValue, itemKey = window.location.pathname) => {
  const key = `${keyPrefix}_${itemKey}`;
  const item = localStorageWithExpiry.getItem(key);

  return [
    item === null ? defaultValue : item,
    (value) => localStorageWithExpiry.setItem(key, value),
  ];
};

export default useLocalStorage;
